import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ipDestination'
})
export class IpDestinationPipe implements PipeTransform {

  transform(ip: string): string {
    return ip.slice(0,-1) + '2';
  }

}
